import { Component, Input, OnInit } from '@angular/core';
import { Line } from '../interfaces/cartObject';
import { ShoppingProducts } from '../interfaces/ShoppingProductsItem';
import * as g from 'src/app/globals';
import { LayoutService } from '@app/layout/layout.service';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';

interface WarehouseOption {
  WarehouseCode: string;
  WarehouseName: string;
}

@Component({
  selector: 'app-warehouse-selector',
  templateUrl: './warehouse-selector.component.html',
  styleUrls: ['./warehouse-selector.component.less'],
})
export class WarehouseSelectorComponent implements OnInit {
  @Input() product: ShoppingProducts;
  @Input() item: Line;

  warehouses: WarehouseOption[] = [];
  selectedWarehouse: WarehouseOption | null = null;
  selectedWarehouseCode = '';
  isLoading = false;
  errorMessage = '';

  constructor(
    public layoutService: LayoutService,
    private drawerRef: NzDrawerRef
  ) {}

  ngOnInit(): void {
    this.selectedWarehouseCode =
      this.product?.WarehouseCode || this.item?.WarehouseCode || '';
    this.getAvailableWarehouses();
  }

  getAvailableWarehouses() {
    this.isLoading = true;
    this.errorMessage = '';

    this.layoutService
      .executeQuery(g.availableWHSForItemQryId, {
        ItemCode: this.product.ItemCode,
        Quantity: this.product.SelectedQuantity,
      })
      .subscribe((item) => {
        this.warehouses = this.sanitizeWarehouses(item);
        this.selectedWarehouse =
          this.warehouses.find(
            (warehouse) =>
              warehouse.WarehouseCode === this.selectedWarehouseCode
          ) || null;
        this.isLoading = false;
      }, () => {
        this.errorMessage = this.layoutService.translate(
          'Unable to load warehouses'
        );
        this.warehouses = [];
        this.selectedWarehouse = null;
        this.isLoading = false;
      });
  }

  selectWarehouse(warehouse: WarehouseOption): void {
    this.selectedWarehouse = warehouse;
    this.selectedWarehouseCode = warehouse.WarehouseCode;
  }

  submit(): void {
    if (!this.selectedWarehouse) {
      return;
    }

    this.product.WarehouseCode = this.selectedWarehouse.WarehouseCode;
    this.product.WarehouseName = this.selectedWarehouse.WarehouseName;

    if (this.item != null) {
      this.item.WarehouseCode = this.selectedWarehouse.WarehouseCode;
    }

    this.drawerRef.close();
  }

  trackByWarehouseCode(index: number, warehouse: WarehouseOption): string {
    return warehouse.WarehouseCode;
  }

  private sanitizeWarehouses(value: any): WarehouseOption[] {
    if (!Array.isArray(value)) {
      return [];
    }

    return value
      .filter(
        (warehouse) =>
          warehouse != null &&
          warehouse.WarehouseCode != null &&
          warehouse.WarehouseCode !== ''
      )
      .map((warehouse) => ({
        WarehouseCode: String(warehouse.WarehouseCode),
        WarehouseName: String(warehouse.WarehouseName || ''),
      }));
  }
}
